import { Component, inject } from '@angular/core';
import {
  DomSanitizer,
  SafeResourceUrl,
} from '@angular/platform-browser';
import { ParametriStampa } from 'src/app/models/parametri-stampa';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { ParametriStampaService } from 'src/app/shared/services/parametri-stampa.service';
import { FormParametriStampaComponent } from 'src/app/shared/components/form/form-parametri-stampa/form-parametri-stampa.component';
import { StorageService } from 'src/app/shared/services/storage.service';
import { GestArticoliBaseComponent } from 'src/app/shared/components/gest-articoli-base/gest-articoli-base.component';

@Component({
  selector: 'app-parametri-stampa',
  templateUrl: './parametri-stampa.component.html',
  styleUrls: ['./parametri-stampa.component.scss'],
  imports: [
    FormParametriStampaComponent,
  ],
  standalone: true,
})
export class ParametriStampaComponent
  extends GestArticoliBaseComponent
{
  private paramateriStampaS = inject(ParametriStampaService);
  private nS = inject(NavigatorService);
  private sanitizer = inject(DomSanitizer);
  private storService: StorageService;

  parametriStampa: ParametriStampa;
  files: any;
  strHeaderBase64: string;
  currentHeader: SafeResourceUrl;
  strFirmaBase64: string;
  currentFirma: SafeResourceUrl;
  tipoparstampadpi='DPI';
  tipoparstampadotazioni='DOTAZIONI';
  
  gestDPI: boolean = false;
  gestDOTAZIONI: boolean=false;
  gest3Livello: boolean=false;

  constructor() {

    super();


    //Categoria - assegno la categoria a seconda del modulo attivo
    this.gestDPI = this.isModVisible('GestioneDPI');
    this.gestDOTAZIONI = this.isModVisible('GestioneDOTAZIONI');
    this.gest3Livello = this.isModVisible('Gestione3Livello');
  }

  getParametri() {
    //this.parametriStampa = new ParametriStampa();

    this.paramateriStampaS.get('DPI').subscribe((dati) => {
      if (dati != null) {
        // console.log(dati);
        this.parametriStampa = dati;
        this.currentHeader = this.sanitizer.bypassSecurityTrustResourceUrl(
          'data:image;base64,' + this.parametriStampa.headerBase64,
        );

        this.currentFirma = this.sanitizer.bypassSecurityTrustResourceUrl(
          'data:image;base64,' + this.parametriStampa.firmaTimbroBase64,
        );

        this.parametriStampa.logoFileName = null;
        this.parametriStampa.headerFileName = null;
        this.parametriStampa.firmaTimbroFileName = null;

        this.parametriStampa.logoBase64 = null;
        this.parametriStampa.headerBase64 = null;
        this.parametriStampa.firmaTimbroBase64 = null;
      }
    });
  }
}

